import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { HeaderActionEventFromHeader, SYMBOL_DETAIL_HEADER_EVENTS } from './symbol-detail-header-events.model';

/**
 * Symbol Detail ← Header action consumer.
 * Listens for header user actions (e.g. back).
 */
@Service({ autoProvided: false })
export class SymbolDetailHeaderEventConsumerService {
	private readonly eventBus = inject(EventBusService);

	readonly headerAction$ = this.eventBus
		.on$<HeaderActionEventFromHeader>(SYMBOL_DETAIL_HEADER_EVENTS.HEADER_ACTION)
		.pipe(
			filter(Boolean),
			distinctUntilChanged((prev, curr) => prev.id === curr.id)
		);
}
